import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import { EditCombiUitvoeringPerDiscipline } from '@components/EditCombiUitvoeringPerDiscipline'

import { useAuthenticatedUser } from '../../../../auth/hooks/useAuthenticatedUser'
import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { Project } from '../../types/Project'

interface Props {
  project: Project
  handleClose: () => void
}

export const CombiUitvoering = ({ project, handleClose }: Props) => {
  const { mutate: saveEvent } = useSaveEvent()
  const { organisatie } = useAuthenticatedUser()

  const disciplineVerzamelingen = project.disciplineVerzamelingen.filter(
    (dv) => dv.netbeheerderLabel === organisatie,
  )

  const [data, setData] = useState(disciplineVerzamelingen)
  const [redenErrors, setRedenErrors] = useState<Record<string, string>>({})

  const validate = (): boolean => {
    const dvErrors = {}
    setRedenErrors(dvErrors)

    for (const dv of data) {
      if (!dv.isCombiUitvoering && !dv.isCombiUitvoeringReden) {
        dvErrors[
          `${dv.disciplineCode}-${dv.netbeheerderCode}-combiuitvoering`
        ] = 'Reden is verplicht bij uit combi melden'
      }
    }

    setRedenErrors(dvErrors)

    return Object.keys(dvErrors).length === 0
  }

  const handleSaveEvent = () => {
    const isValid = validate()

    if (isValid) {
      const eventData = data.map((dv) => {
        if (!dv.isCombiUitvoering && dv.isCombiUitvoeringReden) {
          return {
            isCombiUitvoering: false,
            discipline: dv.disciplineLabel,
            reden: dv.isCombiUitvoeringReden,
          }
        } else {
          return {
            isCombiUitvoering: true,
            discipline: dv.disciplineLabel,
          }
        }
      })

      saveEvent(
        {
          id: project.aanvraagID,
          type: 'combiuitvoering',
          source: 'manual',
          data: {
            disciplines: eventData,
          },
        },
        {
          onSuccess: () => handleClose(),
        },
      )
    }
  }

  return (
    <>
      <DialogTitle>Mee in combi</DialogTitle>

      <DialogContent>
        <EditCombiUitvoeringPerDiscipline
          disciplineVerzamelingen={data}
          onChange={setData}
          redenErrors={redenErrors}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Annuleren
        </Button>

        <Button onClick={handleSaveEvent}>Opslaan</Button>
      </DialogActions>
    </>
  )
}
